<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-industry me-2"></i>{{ TR.manufacturer }}
        </div>

        <div class="card-body">
            <div class="row">
                <div class="col">

                    <DADataTable
                        ref="manufacturer_table_ref"
                        v-if="tableData"
                        :tableData="tableData"
                        :tableOptions="tableOptions"
                    />

                </div>
            </div>
        </div>
    </div>
</template>


<script scoped>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from '@/system_modules/store';
    import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    import DADataTable from "@/components/table/DADataTable";

    export default {
        name: 'ManufacturerP',
        title: 'manufacturer',
        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const manufacturer_table_ref = ref();
            const TR = ref({});

            onMounted(async () => {
                await ajax({
                    url: store.getManufacturer(),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            tableData.value = res;
                            // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                            tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss")));
                        }
                    }
                });
            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: false,
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission('add'),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    modal_width: 30,
                                    page: "components/table/DynamicTable2",
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: 3000000,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            field_type: "text",
                                        },
                                        {
                                            name: "rank",
                                            title: TR.value.rank,
                                            value: () => 1,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission('add'),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name ){
                                                            let formData = new FormData();

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }

                                                            let manufacturer_data = {
                                                                "name": e.name,
                                                                "rank": e.rank,
                                                                "status": e.status,
                                                            };
                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                manufacturer_data.image = e.image;

                                                            formData.append("data", JSON.stringify(manufacturer_data));

                                                            await ajax({
                                                                url: store.getManufacturer(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.push(res);
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                },
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.error(TR.value.msg_add_name_input);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: e => G.privateIfNotAdmin(e),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        method: 'delete',
                                        url: store.getManufacturerUpdate(data.id),
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission('update'),
                            label: "",
                            title: TR.value.edit,
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method ='update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `${data.name}`,
                                    modal_width: 30,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: 3000000,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "name",
                                            value: "name",
                                            title: TR.value.name,
                                            field_type: 'text',
                                        },
                                        {
                                            name: "rank",
                                            value: "rank",
                                            title: TR.value.rank,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission('update'),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        let formData = new FormData();
                                                        if( e.image != data.image && typeof e.image === 'object' ){
                                                            formData.append("upload_image", e.image);
                                                        }
                                                        let manufacturer_data = {
                                                            "name": e.name,
                                                            "rank": e.rank,
                                                            "status": e.status,
                                                        };
                                                        if( e.image != data.image && typeof e.image !== 'object' )
                                                            manufacturer_data.image = e.image;

                                                        formData.append("data", JSON.stringify(manufacturer_data));

                                                        await ajax({
                                                            method: 'patch',
                                                            url: store.getManufacturerUpdate(data.id),
                                                            data: formData,
                                                            success: (x) => {
                                                                let res = x.data || null;
                                                                if (res) {
                                                                    res.create_date = new Date(res.create_date);
                                                                    tableData.value.forEach(
                                                                        (s) => { if ( s.id === res.id ) { s = res; } }
                                                                    );
                                                                    for (let a in res) {
                                                                        data[a] = res[a];
                                                                    }
                                                                    G.alert.success({msg: TR.value.msg_add_success});
                                                                }
                                                            },
                                                        });
                                                        G.closeModal(res);
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getManufacturerActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getManufacturerActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "name",
                            value: (e) => e.name,
                            title: TR.value.name,
                        },
                        {
                            name: "rank",
                            value: "rank",
                            title: TR.value.rank,
                            class: 'text-center',
                            filter: false
                        },
                        // {
                        //     name: "status",
                        //     value: "status",
                        //     title: TR.value.status,
                        //     class: 'text-center',
                        //     filter: false
                        // },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            return {
                TR,
                manufacturer_table_ref,
                tableData,
                tableOptions,
                // getCustomers,
            };
        },
    };
</script>

